import React, { FC } from 'react'
import { Dialog } from 'components/Dialog'
import styles from './DownloadLayerDialog.module.scss'
import { useTranslation } from 'react-i18next'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Flex } from 'components/Flex'
import { Icon } from 'components/Icon'
import { MapServerProvider } from 'providers/request'

type DownloadLayerDialogProps = {
  isOpen: boolean
  onClose: () => void
  file: { name: string; url: string }
  layerid: number
  projectid: string
}

export const DownloadLayerDialog: FC<DownloadLayerDialogProps> = ({ isOpen, onClose, file, layerid, projectid }) => {
  const { t } = useTranslation()
  function downloadcsv() {
    return MapServerProvider.get(`/getcsv/project/${projectid}/layer/${layerid}`)
  }
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      aria-label={t('panel.layers.download')}
      className={styles.downloadLayerDialog}
    >
      <Stack space="large">
        <div>
          <Heading>{t('download_layer_dialog.title')}</Heading>
          <Text>{t('download_layer_dialog.subtitle')}</Text>
        </div>
        <Flex justify="between" align="center">
          <Flex justify="between" align="center" className={styles.fileName}>
            <Icon name="stack-line" size="xl" onClick={downloadcsv}/>
            <Text component="span" >
              
                Descarga CSV
              
            </Text>
          </Flex>
          <a href={`${process.env.REACT_APP_MAP_SERVER_URL}/getcsv/project/${projectid}/layer/${layerid}`} className={styles.downloadIcon}>
            <Icon name="download-line" size="xl" />
          </a>
        </Flex>
      </Stack>
    </Dialog>
  )

}

DownloadLayerDialog.displayName = 'DownloadLayerDialog'
